import {
  AirlineOrderGroupingStatus,
  AirlineOrderGroupingStatusValues,
} from "@/data/entities/airline_order_grouping";
import {
  PackingSlipStatus,
  PackingSlipStatusValues,
} from "@/data/entities/packing_slip";
import {
  PrintingOrderStatus,
  PrintingOrderStatusValues,
} from "@/data/entities/printing_order";
import { ProductStatus, ProductStatusValues } from "@/data/entities/product";
export const resolveStatusColor = (status: string): string => {
  if (status === PackingSlipStatus.SHIPMENT_CREATED) return "warning";
  if (status === PackingSlipStatus.SHIPMENT_NOT_CREATED) return "default";
  if (status === PackingSlipStatus.SHIPMENT_READY) return "success";

  if (status === PrintingOrderStatus.NEW) return "default";
  if (status === PrintingOrderStatus.WAITING_FOR_SAMPLE) return "info";
  if (status === PrintingOrderStatus.WAITING_FOR_APPROVAL) return "secondary";
  if (status === PrintingOrderStatus.SAMPLE_REJECTED) return "danger";
  if (status === PrintingOrderStatus.IN_PRODUCTION) return "primary";
  if (status === PrintingOrderStatus.SHIPPED) return "success";

  if (status === ProductStatus.READY) return "success";
  if (status === ProductStatus.CONCEPT) return "default";

  if (status === AirlineOrderGroupingStatus.SENT) return "success";

  return "default";
};

export const resolveStatusText = (status: any): string => {
  if (PackingSlipStatusValues.includes(status))
    return `packingSlipStatus.${status}`;

  if (PrintingOrderStatusValues.includes(status))
    return `printingOrderStatus.${status}`;

  if (ProductStatusValues.includes(status)) return `productStatus.${status}`;

  if (AirlineOrderGroupingStatusValues.includes(status))
    return `airlineOrderGroupingStatus.${status}`;

  return status;
};
